<template>
<v-container fluid>
	<v-row class="my-2">
		<v-tabs v-model="tab" height="35"
			background-color="primary"
			fixed-tabs
			hide-slider
			dark>
			<v-tab :to="link(item)" ripple
				class="text-capitalize"
				v-for="item in items"
				:key="item"
			>
				{{ item }}
			</v-tab>
		</v-tabs>
	</v-row>
	<v-row class="caption font-weight-bold">
		<span class="ml-4">company: {{company}}</span>
		<span class="ml-4">current round: {{round}}</span>
		<span class="ml-4">year: {{currentYear}}</span>
	</v-row>
	<v-divider class="my-8"></v-divider>
	<v-tabs-items v-model="tab" continuous>
		<v-tab-item value="/customer/market/marketSize">
			<market-size
				:company="company"
				:gameId="gameId"
				:round="round"
			></market-size>
		</v-tab-item>
		<v-tab-item value="/customer/market/designReport">
			<design-report
				:company="company"
				:gameId="gameId"
				:round="round">
			</design-report>
		</v-tab-item>
		<v-tab-item value="/customer/market/m&mReport">
			<mm-report
				:company="company"
				:gameId="gameId"
				:round="round">
			</mm-report>
		</v-tab-item>
		<v-tab-item value="/customer/market/afReport">
			<af-report
				:company="company"
				:gameId="gameId"
				:round="round">
			</af-report>
		</v-tab-item>
		<v-tab-item value="/customer/market/consumersHabits">
			<consumers-habits
				:company="company"
				:gameId="gameId"
				:round="round">
			</consumers-habits>
		</v-tab-item>
		<v-tab-item value="/customer/market/mediaPreferences">
			<media-preferences
				:company="company"
				:gameId="gameId"
				:round="round">
			</media-preferences>
		</v-tab-item>
		<v-tab-item :value="prodValue">
			<products
				:company="company"
				:gameId="gameId"
				:round="round">
			</products>
		</v-tab-item>
		<v-tab-item value="/customer/market/retailReports">
			<retail-reports></retail-reports>
		</v-tab-item>
	</v-tabs-items>
</v-container>
</template>
<script>
	import MarketSize from '../components/reports/market/MarketSize.vue'
	import DesignReport from '../components/reports/market/DesignReport.vue'
	import MmReport from '../components/reports/market/M&MReport.vue'
	import AfReport from '../components/reports/market/AFReport.vue'
	import ConsumersHabits from '../components/reports/market/ConsumersHabits.vue'
	import MediaPreferences from '../components/reports/market/MediaPreferences.vue'
	import Products from '../components/reports/market/Products.vue'
	import RetailReports from '../components/reports/market/RetailReports.vue'

	export default {
		data () {
			return {
				tab: 0,
				items: ['Market size','Design report', 'M&M report', 'AF report', 'Consumers habits','Media preferences', 'Products', 'Retail reports']
			}
		},
		computed: {
			company () {
				return this.$store.getters.company
			},
			currentYear () {
				return this.$store.getters.currentYear
			},
			round () {
				return this.$store.getters.currentRound
			},
			gameId () {
				return this.$store.getters.gameId
			},
			prodValue () {
				return `/customer/market/products?game=${this.gameId}&round=${parseInt(this.round) - 1}`
			}

		},
		methods: {
			link (item) {
				const item_arr = item.split(' ')
				const first = item_arr[0].toLowerCase()
				let second = `?game=${this.gameId}&round=${parseInt(this.round) - 1}`;

				if (item_arr[1]) {
					second = item_arr[1][0].toUpperCase() + item_arr[1].substr(1)
				}				
				return `/customer/market/${first + second}`
			}
		},
		components: {
			MarketSize,
			DesignReport,
			MmReport,
			AfReport,
			ConsumersHabits,
			MediaPreferences,
			RetailReports,
			Products
		}
	}
</script>